module.exports = __webpack_public_path__ + "img/kiss.3b05934e.jpg";